<!-- Location Selection -->
@if (showLocationSection() && hasLocations) {
  <div class="config-field">
    <label class="field-label">Locations</label>
    <div class="location-mode-toggle">
      <button
        type="button"
        class="mode-btn"
        [class.active]="applyToAllLocations"
        (click)="onLocationModeChange('all')"
      >
        <span class="material-symbols-outlined">select_all</span>
        All Locations ({{ locations().length }})
      </button>
      <button
        type="button"
        class="mode-btn"
        [class.active]="!applyToAllLocations"
        (click)="onLocationModeChange('select')"
      >
        <span class="material-symbols-outlined">checklist</span>
        Select Specific
      </button>
    </div>
    @if (!applyToAllLocations) {
      <div class="location-selector-wrapper">
        <app-multi-value-selector
          [options]="locationOptions"
          [showSearch]="locationOptions.length > 5"
          [showIcon]="true"
          placeholder="Select locations..."
          searchPlaceholder="Search locations..."
          selectAllLabel="All Locations"
          [ngModel]="selectedLocationIdArray"
          (ngModelChange)="onLocationIdsChange($event)"
        />
      </div>
      <span class="help-text">{{ selectedLocationsCount }} of {{ locations().length }} selected</span>
    }
  </div>
}

<!-- Price per location -->
@if (showPriceSection()) {
<div class="config-field">
  <label class="field-label">Price per {{ showLocationSection() && hasLocations ? 'location' : 'unit' }}</label>
  <div class="price-type-row">
    <label class="radio-option">
      <input type="radio" name="priceType" [checked]="useDefaultPrice" (change)="onPriceTypeChange(true)">
      <span>Default ({{ formatCurrency(defaultPrice()) }}/{{ billingCycleLabel() }})</span>
    </label>
    <label class="radio-option">
      <input type="radio" name="priceType" [checked]="!useDefaultPrice" (change)="onPriceTypeChange(false)">
      <span>Custom price</span>
    </label>
  </div>
  @if (!useDefaultPrice) {
    <div class="custom-price-row">
      <div class="input-with-addon">
        <span class="addon-left">$</span>
        <input type="number" class="price-input" [(ngModel)]="customPrice" (ngModelChange)="onCustomPriceChange()" min="0" step="0.01" placeholder="0.00">
        <span class="addon-right">/{{ billingCycleLabel() }}</span>
      </div>
    </div>
    @if (discountAmount > 0) {
      <div class="discount-note">
        <span class="material-symbols-outlined">savings</span>
        {{ formatCurrency(discountAmount) }} discount from catalog price
      </div>
    }
  }
</div>
}